import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChart5: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChart5"><Path d="M9.5 3V21.001H14.5V3H9.5Z" fill="currentColor"/><Path d="M3 13V21H8V13H3Z" fill="currentColor"/><Path d="M16 21.001V8H21V21.001H16Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChart5;
